import React, { useState, useEffect, useRef } from "react";
import { getTime, StyledTime } from "../Timer";

interface DigitSymbolTimerProps {
  seconds: number;
  paused?: boolean;
  onDone: React.Dispatch<boolean>;
  onPause?: React.Dispatch<boolean>;
  activeQuestion?: number;
  hidden?: boolean;
  setEndTime?: React.Dispatch<Date>;
}

const Timer: React.FC<DigitSymbolTimerProps> = ({
  seconds,
  paused,
  onDone,
  activeQuestion,
  hidden,
  setEndTime: setTimeOfAttempt
}: DigitSymbolTimerProps) => {
  const [secondsLeft, setSecondsLeft] = useState(seconds);
  const showMilliseconds = !Number.isInteger(seconds);
  const startTimeRef = useRef<number>(0);
  const pausedTimeRef = useRef<number>(0);

  // reset timer when props are the same between questions
  useEffect(() => {
    setSecondsLeft(seconds);
    onDone(false);
    startTimeRef.current = Date.now();
    pausedTimeRef.current = 0;
  }, [activeQuestion]);

  useEffect(() => {
    const timer: number = setInterval(() => {
      if (!paused) {
        const elapsed =
          Date.now() - startTimeRef.current - pausedTimeRef.current;
        const remaining = Math.max(seconds - elapsed / 1000, 0);
        setSecondsLeft(remaining);
        const time = getTime(remaining, showMilliseconds, hidden);
        if (time.done) {
          clearInterval(timer);
          if (setTimeOfAttempt) {
            setTimeOfAttempt(new Date());
          }
          onDone(true);
        }
      } else {
        // While paused, accumulate the paused time
        pausedTimeRef.current += 8; // same as interval delay
      }
    }, 8); // check every 8ms

    return () => clearInterval(timer);
  }, [paused, seconds, onDone]);

  const time = getTime(secondsLeft, showMilliseconds, hidden);

  return <StyledTime {...time} />;
};

export default Timer;
